import { message } from "antd";

const useCopy = () => {
  const handleCopy = (text: string | undefined) => {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        message.success(`Copied: ${text}`);
      });
    }
  };

  return handleCopy;
};

export default useCopy;
